exports = module.exports = require("../../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.weather-station[data-v-ece84412] {\n  font-size: 0;\n}\n.tip-text[data-v-ece84412],\n.station-name[data-v-ece84412],\n.station-select[data-v-ece84412] {\n  display: inline-block;\n  vertical-align: top;\n}\n.tip-text[data-v-ece84412] {\n  font-size: 24px;\n  color: #ffffff;\n  font-weight: bolder;\n  line-height: 40px;\n  margin-left: 40px;\n}\n.station-name[data-v-ece84412] {\n  font-size: 24px;\n  color: #ffffff;\n  line-height: 40px;\n  margin-left: 30px;\n}\n.station-select[data-v-ece84412] {\n  margin-left: 15px;\n  display: inline-block;\n  vertical-align: top;\n  height: 36px;\n  margin-top: 2px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.28.11@css-loader?{"minimize":false,"sourceMap":false}!./~/_vue-loader@11.3.4@vue-loader/lib/style-compiler?{"id":"data-v-ece84412","scoped":true,"hasInlineConfig":true}!./~/_less-loader@4.0.5@less-loader/dist/cjs.js?{"sourceMap":false}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=styles&index=0!./src/views/weatherInfo/weather-station.vue
// module id = 735
// module chunks = 1